export const SERVICES_TAGS: { [key: string]: string } = {};

export const FIXED_CACHE_KEYS = {};
